export default "__VITE_ASSET__0795c3fd__"